// extracted by mini-css-extract-plugin
module.exports = {"callout":"Callout_callout__u1Qjx"};